import "@fortawesome/fontawesome-free/css/all.min.css";
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.material.blue.light.compact.css";

import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import React from "react";
import { YMaps as Map } from "react-yandex-maps";
import { BrowserRouter, Route, Switch, withRouter } from "react-router-dom";
import { Redirect } from 'react-router';
import RouteAdviceContext from "./RouteAdviceContext";
import AppSidebar from "./AppSidebar";
import AppToolbar from "./AppToolbar";
import SecuredRoute from "./SecuredRoute";
import PersonTable from "./ManageOOP/Resources/Person/pages/PersonList";
import PersonView from "./ManageOOP/Resources/Person/pages/PersonView";
import OrganizationsList from './Organizations/pages/OrganizationsList';
import OrganizationEdit from "./Organizations/pages/OrganizationsEdit";
import FacilitiesTable from "./Facility/pages/FacilitiesList";
import FacilityEdit from "./Facility/pages/FacilityEdit";
import EntityNotFound from "./util/EntityNotFound";
import DictCompetFGOS from "./ManageOOP/Resources/DictCompetFGOS/Index"
import DictSkills from "./Dict/Skills/DictSkills/DictSkills";
import DictSpeciality from "./Dict/Skills/Speciality/DictSpeciality";
import Skill from "./Dict/Skills/Skill/Skill";
import SiteTable from "./ManageOOP/Resources/InfCommunication/pages/ResourceList";
import SiteView from "./ManageOOP/Resources/InfCommunication/pages/ResourceView";
import ReferenceTable from "./ManageOOP/Resources/InfReference/pages/ResourceList";
import ReferenceView from "./ManageOOP/Resources/InfReference/pages/ResourceView";
import SkillView from "./Dict/Skills/Skill/View/SkillView";
import RoomsTable from "./Room/pages/RoomsList";
import SkillEdit from "./Constructor/Competence/pages/CompetenceEdit";
import Constructor from "./Constructor/Index"
import CompetenceTable from "./Constructor/Competence/pages/CompetenceList";
import ExpertiseTable from "./Constructor/Expert/pages/ExpertiseList";
import ModuleTable from "./Constructor/Module/pages/ModuleList";
import ModuleEdit from './Constructor/Module/components/ModuleEdit'
import ProgramTable from "./Constructor/Program/pages/ProgramList";
import ProgramConstructorEdit from "./Constructor/Program/pages/ProgramEdit";
import ManageResources from "./ManageOOP/Resources/Index"
import ResourcesOrg from "./ManageOOP/Resources/Organizations/Index"
import OrgRequestTable from "./ManageOOP/Resources/Organizations/OrgRequests/pages/OrgRequestList"
import OrgRequestView from "./ManageOOP/Resources/Organizations/OrgRequests/pages/OrgRequestView"
import ResourcesMatTech from "./ManageOOP/Resources/MatTech/Index"
import MatTechNomenclature from "./ManageOOP/Resources/MatTech/Nomenclature";
import ResourcesOPMod from "./ManageOOP/Resources/OpMod/Index"
import ResourcesManageExpertiseTable from "./ManageOOP/Resources/OpMod/ManageExpertise/pages/ExpertiseList";
import ResourcesMyOPModuleTable from "./ManageOOP/Resources/OpMod/MyOPMod/pages/MyOpModuleList";
import ResourcesMyOPProgramTable from "./ManageOOP/Resources/OpMod/MyOPMod/pages/MyOpProgramList";
import ResourcesMyOPMasterClassTable from "./ManageOOP/Resources/OpMod/MasterClass/pages/MasterClassList";
import ProgramView from "./ManageOOP/Resources/OpMod/MyOPMod/pages/ProgramView";
import ModuleView from "./ManageOOP/Resources/OpMod/MyOPMod/pages/ModuleView";
import MasterClassView from "./ManageOOP/Resources/OpMod/MasterClass/pages/MasterClassView";
import ManageOrders from "./ManageOOP/ManageOrders"
import OrgOrders from "./ManageOOP/Orders/OrgOrders"
import MyInboxOrders from "./ManageOOP/Orders/OrgOrders/MyInboxOrders/pages/MyInOrderList"
import MyOutboxOrders from "./ManageOOP/Orders/OrgOrders/MyOutboxOrders/pages/MyOutOrderList"
import CoppOrdersTable from "./ManageOOP/Orders/CoppOrders/pages/CoppOrderList"
import OrdersCustomers from "./ManageOOP/Orders/Customers";
import PortfolioCustomersTable from "./ManageOOP/Orders/Customers/PortfolioCustomers/pages/PortCustList";
import PortfolioContractsTable from "./ManageOOP/Orders/Customers/PortfolioContracts/pages/PortContrList";
import ConfirmationDialog from "./ui/ConfirmationDialog";
import RoomEdit from "./Room/pages/RoomEdit";
import ResourceTable from "./Resources/pages/ResourceList";
import ResourceEdit from "./Resources/pages/ResourceEdit";
import Catalog from "./Catalog";
import CatalogProgramView from "./Catalog/CatalogProgramView";
import Dashboard from "./Dashboard";
import ScheduleView from "./Schedule/pages/ScheduleView";
import Quiz from "./Quiz";
import ActiveQuiz from "./Quiz/EnjoyQuiz/pages/QuizSessionList";
import QuizTable from "./Quiz/ManageQuiz/pages/QuizList";
import QuizView from "./Quiz/ManageQuiz/pages/QuizView";
import QuestionRequestList from "./Service/QuestionRequest/pages/QuestionRequestList";
import UserList from "./ManageOOP/Resources/Users/pages/UserList";
import StudyRequestView from "./Study/Requests/pages/StudyRequestView";


const MainToolbarWithRouter = withRouter(AppToolbar);
const MainSidebarWithRouter = withRouter(AppSidebar);

class App extends React.Component {
  constructor(props) {
    super(props);

    this.routeAdviceRef = {
      aroundInvoke: null,
      callback: null
    };
    this.state = {
      opened: false,
      confirmMessage: "Данные были изменены, сохранить перед продолжением?",
      confirmVisible: false,
    };

    this.getUserConformation = this.getUserConformation.bind(this);
    this.handleExpandClick = this.handleExpandClick.bind(this);
    this.handleUserConfirmYes = this.handleUserConfirmYes.bind(this);
    this.handleUserConfirmNo = this.handleUserConfirmNo.bind(this);
    this.handleUserConfirmCancel = this.handleUserConfirmCancel.bind(this);
  }

  componentDidMount() {}

  getUserConformation(msg, callback) {
    this.setState({
      confirmMessage: msg,
      confirmVisible: true
    });
    this.routeAdviceRef.callback = callback;
  }

  handleUserConfirmYes() {
    this.setState({
      confirmVisible: false
    });
    if (this.routeAdviceRef.callback != null) {
      if (typeof this.routeAdviceRef.aroundInvoke === "function") {
        this.routeAdviceRef.aroundInvoke(this.routeAdviceRef.callback);
      } else {
        this.routeAdviceRef.callback(true);
      }
    }
  }

  handleUserConfirmNo() {
    this.setState({
      confirmVisible: false
    });
    if (this.routeAdviceRef.callback != null) {
      this.routeAdviceRef.callback(true);
    }
  }

  handleUserConfirmCancel() {
    this.setState({
      confirmVisible: false
    });
    if (this.routeAdviceRef.callback != null) {
      this.routeAdviceRef.callback(false);
    }
  }

  handleExpandClick() {
    this.setState(state => {
      return {
        opened: !state.opened
      };
    });
  }

  render() {
     return (
      <BrowserRouter getUserConfirmation={this.getUserConformation}>
        <RouteAdviceContext.Provider value={this.routeAdviceRef}>
          <Map>
            <div >
              <MainToolbarWithRouter onMenuClick={this.handleExpandClick} />
              <div>
                <MainSidebarWithRouter
                  opened={this.state.opened}
                  setOpen={this.handleExpandClick}
                />
                <div>
                  {" "}
                  {/* Workaround T713569 */}
                  <Switch>
                    <Redirect exact from="/" to="/work/app/dashboard" />
                    <Redirect exact from="/work/app" to="/work/app/dashboard" />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/dashboard"
                      component={Dashboard}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/dict"
                      component={() => {
                        window.location.href = '/app/manage/service_dict?open=flow';
                        return null;
                      }}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/catalog"
                      component={Catalog}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/catalog/program/:id"
                      component={CatalogProgramView}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/schedule"
                      component={() => {
                        window.location.href = '/app/manage/schedule?open=flow';
                        return null;
                      }}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/schedule/:id"
                      component={ScheduleView}
                    />
                    <SecuredRoute
                      role={"quiz_developer"}
                      exact
                      path="/work/app/quiz"
                      component={Quiz}
                    />
                    <SecuredRoute
                      role={"quiz_developer"}
                      exact
                      path="/work/app/quiz/active"
                      component={ActiveQuiz}
                    />
                    <SecuredRoute
                      role={"quiz_developer"}
                      exact
                      path="/work/app/quiz/manage"
                      component={QuizTable}
                    />
                    <SecuredRoute
                      role={"quiz_developer"}
                      exact
                      path="/work/app/quiz/manage/:id"
                      component={QuizView}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/manage/resources/competfgos"
                      component={DictCompetFGOS}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/dict/skills"
                      component={DictSkills}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/dict/skills/speciality"
                      component={DictSpeciality}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/dict/skills/skill"
                      component={Skill}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/constructor/competences/:id"
                      component={SkillEdit}
                    />
                     <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/dict/skills/skill/:id"
                      component={SkillView}
                    />

                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/person"
                      component={PersonTable}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/person/:id"
                      component={PersonView}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/organization"
                      component={OrganizationsList}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/organization/:id"
                      component={OrganizationEdit}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/facilities/"
                      component={FacilitiesTable}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/facilities/:id"
                      component={FacilityEdit}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/rooms/"
                      component={RoomsTable}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/rooms/:id"
                      component={RoomEdit}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/site"
                      component={SiteTable}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/site/:id"
                      component={SiteView}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/reference"
                      component={ReferenceTable}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/reference/:id"
                      component={ReferenceView}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/resources/"
                      component={ResourceTable}
                      />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/constructor"
                      component={Constructor}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/constructor/competences"
                      component={CompetenceTable}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/constructor/expertise"
                      component={ExpertiseTable}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/constructor/modules"
                      component={ModuleTable}
                    />
					<SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/constructor/edit-module"
                      component={ModuleEdit}
                    />
					<SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/constructor/edit-module/:id"
                      component={ModuleEdit}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/constructor/programs"
                      component={ProgramTable}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/constructor/edit-program/:id"
                      component={ProgramConstructorEdit}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/resources/:id"
                      component={ResourceEdit}
                      />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/manage/resources"
                      component={ManageResources}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/manage/resources/org"
                      component={ResourcesOrg}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/manage/resources/org/requests"
                      component={OrgRequestTable}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/manage/resources/org/requests/:id"
                      component={OrgRequestView}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/manage/resources/mattech"
                      component={ResourcesMatTech}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/manage/resources/mattech/nomenclature"
                      component={MatTechNomenclature}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/manage/resources/programs"
                      component={ResourcesOPMod}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/manage/resources/programs/my-programs"
                      component={ResourcesMyOPProgramTable}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/manage/resources/programs/my-modules"
                      component={ResourcesMyOPModuleTable}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/manage/resources/programs/my-master-classes"
                      component={ResourcesMyOPMasterClassTable}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/manage/resources/master-class/:id"
                      component={MasterClassView}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/manage/resources/programs/myprograms/:id"
                      component={ProgramView}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/manage/resources/programs/mymodules/:id"
                      component={ModuleView}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/manage/resources/programs/expertise"
                      component={ResourcesManageExpertiseTable}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/manage/orders"
                      component={ManageOrders}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/manage/orders/orgorders"
                      component={OrgOrders}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/manage/orders/orgorders/myinbox"
                      component={MyInboxOrders}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/manage/orders/orgorders/myoutbox"
                      component={MyOutboxOrders}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/manage/orders/copporders"
                      component={CoppOrdersTable}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/manage/orders/customers"
                      component={OrdersCustomers}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/manage/orders/customers/custlist"
                      component={PortfolioCustomersTable}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/manage/orders/customers/contracts"
                      component={PortfolioContractsTable}
                    />
                    <SecuredRoute
                      exact
                      path="/work/app/study"
                      component={() => {
                        window.location.href = '/app/manage';
                        return null;
                      }}
                    />
                    <SecuredRoute
                      exact
                      path="/work/app/study/plan"
                      component={() => {
                        window.location.href = '/app/manage/group_appointment?open=flow';
                        return null;
                      }}
                    />
                    <SecuredRoute
                      exact
                      path="/work/app/study/groups"
                      component={() => {
                        window.location.href = '/app/manage/group?open=flow';
                        return null;
                      }}
                    />
                    <SecuredRoute
                      exact
                      path="/work/app/study/registry"
                      component={() => {
                        window.location.href = '/app/manage/person_student?open=flow';
                        return null;
                      }}
                    />
                    <SecuredRoute
                      exact
                      path="/work/app/study/schoolchild-archive/registry"
                      component={() => {
                        window.location.href = '/app/manage/arch_student?open=flow';
                        return null;
                      }}
                    />
                    <SecuredRoute
                      exact
                      path="/work/app/study/request"
                      component={() => {
                        window.location.href = '/app/manage/request_program?open=flow';
                        return null;
                      }}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/study/request/:id"
                      component={StudyRequestView}
                    />
                    <SecuredRoute
                      role={"admin"}
                      exact
                      path="/work/app/manage/resources/users"
                      component={UserList}
                    />
                    <SecuredRoute role={"admin"} component={QuestionRequestList} exact
                                  path="/work/app/service/question-request" />
                    <Route component={EntityNotFound} />
                  </Switch>
                </div>
                <ConfirmationDialog />
                <Dialog
                  disableBackdropClick
                  disableEscapeKeyDown
                  maxWidth={"xs"}
                  open={this.state.confirmVisible}
                >
                  <DialogTitle>Подтверждение перехода</DialogTitle>
                  <DialogContent dividers>
                    <p>{this.state.confirmMessage}</p>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      variant="contained"
                      autoFocus
                      onClick={this.handleUserConfirmYes}
                      color="primary"
                    >
                      Да
                    </Button>
                    <Button
                      variant="contained"
                      onClick={this.handleUserConfirmNo}
                      color="secondary"
                    >
                      Нет
                    </Button>
                    <Button
                      variant="contained"
                      onClick={this.handleUserConfirmCancel}
                    >
                      Отмена
                    </Button>
                  </DialogActions>
                </Dialog>
              </div>
            </div>
          </Map>
        </RouteAdviceContext.Provider>
      </BrowserRouter>

    );
  }
}

export default App;
